var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3998 3.90039V5.70039H6.5998V9.30039C6.5998 11.2894 8.2108 12.9004 10.1998 12.9004C12.1888 12.9004 13.7998 11.2894 13.7998 9.30039V5.70039H11.9998V3.90039H14.6998C15.1966 3.90039 15.5998 4.30359 15.5998 4.80039V9.30039C15.5998 11.9761 13.654 14.1964 11.0998 14.6257V16.0504C11.0998 17.7901 12.5101 19.2004 14.2498 19.2004C15.5971 19.2004 16.7473 18.3544 17.1973 17.1637C16.255 16.7434 15.5998 15.7984 15.5998 14.7004C15.5998 13.2091 16.8085 12.0004 18.2998 12.0004C19.7911 12.0004 20.9998 13.2091 20.9998 14.7004C20.9998 15.9343 20.1718 16.9747 19.0414 17.2969C18.4888 19.4272 16.5529 21.0004 14.2498 21.0004C11.5156 21.0004 9.2998 18.7846 9.2998 16.0504V14.6257C6.7456 14.1973 4.7998 11.9761 4.7998 9.30039V4.80039C4.7998 4.30359 5.203 3.90039 5.6998 3.90039H8.3998ZM18.2998 13.8004C17.803 13.8004 17.3998 14.2036 17.3998 14.7004C17.3998 15.1972 17.803 15.6004 18.2998 15.6004C18.7966 15.6004 19.1998 15.1972 19.1998 14.7004C19.1998 14.2036 18.7966 13.8004 18.2998 13.8004Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.c192e48e39ea780786f2c5c423e9c60f.svg";
export { ForwardRef as ReactComponent };